import { createBrowserHistory } from 'history';

/**
 * History of choice
 * Browser history is used in this case
 */

export const history = createBrowserHistory();
